// Generated by ReScript, PLEASE EDIT WITH CARE

function isDescendent(ancestor, _descendent) {
  while (true) {
    var descendent = _descendent;
    var parent = descendent.parentElement;
    if (parent == null) {
      return false;
    }
    if (parent === ancestor) {
      return true;
    }
    _descendent = parent;
    continue;
  }
  ;
}
function scrollIntoViewWithOptions(options, element) {
  element.scrollIntoView(options);
}
export { isDescendent, scrollIntoViewWithOptions };
/* No side effect */